export const sessionStore = {
  activeIntent: null,
  payload: {},
  lastAskedField: null
};
